import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../components/HeaderComponent';
import { Layout, Modal, Row, Switch } from 'antd';
import ReactTable from 'react-table';
import {
  getFeaturedNetworkCenters,
  updateFeaturedNetworkCenter,
  updateFeaturedNetworkCentersPriority,
} from '../../services/api/cashless-vaccination';
import SidebarComponent from '../../components/sidebarComponent';

export default function FeaturedCenterList(props) {
  const { history, location = {} } = props;
  const [featuredCentersList, setFeaturedCenterList] = useState([]);
  const [filteredCentersList, setFilteredCentersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateLoader, setUpdateLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [priorityArray, setPriorityArray] = useState([]);
  const [priority, setPriority] = useState('');
  const [loader, setLoader] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  console.log(location, 'location');
  useEffect(() => {
    fetchFeaturedNetworkCenters();
  }, []);

  useEffect(() => {
    if (location.state && location.state.selectedCity) {
      const filteredCenters = featuredCentersList.filter(
        (item) => item.city.trim() === location.state.selectedCity
      );
      setFilteredCentersList(filteredCenters);
    }
  }, [location.state, featuredCentersList]);

  const fetchFeaturedNetworkCenters = () => {
    return getFeaturedNetworkCenters()
      .then((response) => {
        setFeaturedCenterList(response.body.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const getColums = () => [
    {
      Header: 'Featured Network Centers',
      columns: [
        {
          Header: 'Network Center Id',
          accessor: 'id',
          Cell: (row) => (
            <div>
              <a
                onClick={() =>
                  props.history.push(`/center-profile/${row.original.id}`)
                }
              >
                {row.original.id}
              </a>
            </div>
          ),
        },
        {
          Header: 'Network Center Name',
          accessor: 'title',
          Cell: (row) => {
            return row.original.title;
          },
        },
        {
          Header: 'City',
          accessor: 'city',
          Cell: (row) => {
            return row.original.city;
          },
        },
        {
          Header: 'Address',
          accessor: 'address',
          Cell: (row) => {
            return row.original.address;
          },
        },
        {
          Header: 'State',
          accessor: 'state',
          Cell: (row) => {
            return row.original.state;
          },
        },
        {
          Header: 'Featured',
          accessor: 'showCenterRequest',
          Cell: (row) => (
            <div>
              <Switch
                checked={row.original.showCenterRequest}
                onChange={(e) => updateDetails(row.original.id)}
              />
            </div>
          ),
        },
        {
          Header: 'Current Priority',
          accessor: 'priority',
          Cell: (row) => {
            return row.original.centerPriority;
          },
        },
        {
          Header: 'Set New Priority',
          accessor: 'priority',
          Cell: (row) => {
            return (
              <input
                // value={row.original.centerPriority}
                onChange={(e) => setPriority(e.target.value)}
                onBlur={(e) => setPriorities(row.original.id)}
              />
            );
          },
        },
      ],
    },
  ];

  const hasDuplicates = (arr) => arr.length !== new Set(arr).size;

  const updateNetworkCenterPriority = (e) => {
    e.preventDefault();
    setLoader(true);
    const body = {
      priorityArray: priorityArray,
    };
    const centersForWhichPriorityIsSet = filteredCentersList.filter(
      (item) => item.centerPriority
    );
    const priorities = priorityArray.map((item) => parseInt(item.priority));
    const allCenterIds = priorityArray.map((item) => item.centerId);
    const centersForWhichPriorityNotUpdating =
      centersForWhichPriorityIsSet.filter(
        (item) => !allCenterIds.includes(item.id)
      );
    if (centersForWhichPriorityNotUpdating.length) {
      console.log(
        centersForWhichPriorityNotUpdating,
        priorities,
        'centersForWhichPriorityNotUpdating'
      );
      const centersWithExistingPriority =
        centersForWhichPriorityNotUpdating.filter((item) =>
          priorities.includes(item.centerPriority)
        );
      console.log(centersWithExistingPriority, 'centersWithExistingPriority');
      if (centersWithExistingPriority.length) {
        alert(
          `Priority ${centersWithExistingPriority[0].centerPriority} is already set for ${centersWithExistingPriority[0].title}(${centersWithExistingPriority[0].id}). Please set a different priority.`
        );
        setLoader(false);
        return;
      }
    }
    if (hasDuplicates(priorities)) {
      alert('Two centers cannot have same priority');
      setLoader(false);
      return;
    }
    return updateFeaturedNetworkCentersPriority(body)
      .then((response) => {
        console.log('updated center priorities');
        // fetchFeaturedNetworkCenters();
        setLoader(false);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  const setPriorities = (centerId) => {
    if (!(centerId && priority.trim())) {
      return;
    }
    const priorityObj = {
      centerId,
      priority,
    };
    console.log(priorityObj);
    let objIndex = priorityArray.findIndex((item) => item.centerId == centerId);
    if (objIndex == -1) {
      setPriorityArray([...priorityArray, priorityObj]);
    } else {
      let newPriorityArray = [...priorityArray];
      newPriorityArray[objIndex].priority = priority;
      setPriorityArray([...newPriorityArray]);
    }
    setPriority('');
  };

  const updateDetails = (centerId) => {
    const body = {
      centerId: centerId,
    };
    setShowModal(true);
    setUpdateLoader(true);

    console.log(body, 'body');
    updateFeaturedNetworkCenter(body)
      .then((res) => {
        console.log(res, 'res');
        if (res.body.message === 'success') {
          setUpdateLoader(false);
          setLoader(false);
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleOk = () => {
    setShowModal(false);
    window.location.reload();
  };

  console.log(showModal);
  return (
    <>
      <Layout  >
        <div>
          <HeaderComponent />
          <div style={{
            display: 'flex',
          }}>
            <div style={{ zIndex: 1000 }}>

              <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            </div>
            <div style={{ width: '100%' , padding: '4px 8px 8px 8px'}}>

        {location.state && location.state.selectedCity && (
          <>
            <Layout>
              <Row>
                <ReactTable
                  data={filteredCentersList}
                  columns={getColums()}
                  showPaginationTop
                  showPaginationBottom
                  loading={loading}
                  minRows={1}
                />
              </Row>
            </Layout>
            <button
              style={{
                backgroundColor: '#1a73e8',
                color: 'white',
                marginTop: '20px',
                height: '30px',
                cursor: 'pointer',
              }}
              disabled={priorityArray.length == 0 || loader}
              onClick={(e) => updateNetworkCenterPriority(e)}
            >
              Submit priority
            </button>
          </>
        )}
            </div></div></div>
      </Layout>

      <Modal
        title="Center Details"
        visible={showModal}
        onOk={handleOk}
        confirmLoading={updateLoader}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>Center Details updated.</p>
      </Modal>
    </>
  );
}
